import {
  Swiper,
  Navigation,
  Pagination,
  Keyboard,
  Autoplay,
  EffectFade,
  // Scrollbar,
} from 'swiper';
  
Swiper.use([Navigation, Pagination, Keyboard, Autoplay, EffectFade]);
  
const navigation = (target) => {
  return {
    nextEl: `.${target}-swiper-button--next`,
    prevEl: `.${target}-swiper-button--prev`,
  };
};
  
$(window).on('load', function () {
  swipers();
});

const swipers = () => {
  logoSwiper();
  partnerSwiper();
};

const logoSwiper = () => {
  return new Swiper('.module--logo__swiper', {
    loop: true,
    freeMode: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    freeModeMomentum: false,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 6000,
  });
}

const partnerSwiper = () => {
  return new Swiper('.partners__swiper', {
    loop: false,
    freeMode: true,
    spaceBetween: 30,
    centerInsufficientSlides: true,
    freeModeMomentum: false,
    navigation: navigation('partners__nav__swiper'),
    breakpoints: {
      1200: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 3,
      },
      0: {
        slidesPerView: 2,
      },
    },
    on: {
      init: function () {
        if ($('.partners__nav .swiper-button-disabled').length == 2) {
          $('.partners__nav .swiper-controls').removeClass('d-flex').addClass('d-none');
        } else {
          $('.partners__nav .swiper-controls').removeClass('d-none').addClass('d-flex');
        }
      },
    },
  });
}
